import request from '@/utils/request'
import URL from './urlTranslator'

// 邮件发送
export function updateTrackingForDocumentType(data) {
  return request({
    url: URL.seaExport.updateTrackingForDocumentType,
    method: 'post',
    data
  })
}

// 文件上传批量更新job状态跟踪
export function batchUpdateTrackingForDocumentType(data) {
  return request({
    url: URL.seaExport.batchUpdateTrackingForDocumentType,
    method: 'post',
    data
  })
}

// 文件上传更新 job状态跟踪,用于财务[付款申请、发票、销账]
export function changeSopForFinance(data) {
  return request({
    url: URL.seaExport.changeSopForFinance,
    method: 'post',
    data
  })
}

// 文件上传/删除/修改后刷新打印状态
export function refreshPrintStatus(jobUuid) {
  return request({
    url: URL.seaExport.refreshPrintStatus,
    method: 'get',
    params: { jobUuid }
  })
}
